var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.83 22.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: .38px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #8af3e5;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        stroke-width: .58px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.15,14.53c-1.72-1.81-1.65-4.66,.16-6.38,1.81-1.72,4.66-1.65,6.38,.16,1.72,1.81,1.65,4.66-.16,6.38-1.81,1.72-4.66,1.65-6.38-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.8,17.72c-3.48-3.66-3.34-9.44,.32-12.92,3.66-3.48,9.44-3.34,12.92,.32,3.48,3.66,3.34,9.44-.32,12.92-3.66,3.48-9.44,3.34-12.92-.32Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.58,
    y1: 15.52,
    x2: 15.64,
    y2: 13.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.11,
    y1: 19.77,
    x2: 12.93,
    y2: 15.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.25,
    y1: 7.31,
    x2: 7.19,
    y2: 9.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.72,
    y1: 3.06,
    x2: 9.9,
    y2: 7.11
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.52,
    y1: 3.25,
    x2: 13.15,
    y2: 7.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.77,
    y1: 7.72,
    x2: 15.72,
    y2: 9.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.31,
    y1: 19.58,
    x2: 9.68,
    y2: 15.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.06,
    y1: 15.11,
    x2: 7.11,
    y2: 12.93
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.17,17.59l.28,.29c.24,.26,.23,.66-.02,.91h0c-.26,.24-.66,.23-.91-.02l-.27-.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.66,5.24l-.27-.29c-.24-.26-.23-.66,.02-.91h0c.26-.24,.66-.23,.91,.02l.27,.29"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.59,4.66l.29-.28c.26-.24,.66-.23,.91,.02h0c.24,.26,.23,.66-.02,.91l-.29,.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.24,18.18l-.29,.28c-.26,.24-.66,.23-.91-.02h0c-.24-.26-.23-.66,.02-.91l.29-.28"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.54,17.95s9.01-5.6,.31-12.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.59,18.85s-6.04,8.73-12.71-.32"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.25,3.98s6.03-8.73,12.71,.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.29,4.89s-9.01,5.6-.31,12.71"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSos);
export default __webpack_public_path__ + "static/media/sos.d37ad8d70c945a3fec369ffafc9b9abf.svg";
export { ForwardRef as ReactComponent };